module.exports = __webpack_public_path__ + "static/media/StripesBlue.ee977539.png";